module.exports = __webpack_public_path__ + "img/singleLeg.0d17dad8.png";